import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlined';
import { Box, Button, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import {
  RECEIVABLES_DATE_COLUMN_INDEXES,
  RECEIVABLES_TABLE_ARIA_LABEL,
  RECEIVABLES_TABLE_COLUMN_WIDTHS,
  RECEIVABLES_TABLE_HEADERS,
  RECEIVABLES_TABLE_MIN_WIDTH,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/receivables/constants.ts';
import { ReceivableRow } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/receivables/ReceivableRow.tsx';
import { FinancialConditionTable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTable.tsx';
import type { IReceivablesSectionProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/receivables/types.ts';
import {
  BorrowerType,
  type TFinancialConditionFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { createReceivable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const ReceivablesSection: React.FC<IReceivablesSectionProps> = ({ disabled }) => {
  const { control, watch } = useFormContext<TFinancialConditionFormValues>();
  const borrowerType = watch('borrowerType')?.value;
  const isLegalEntity = borrowerType === BorrowerType.LegalEntity;
  const { fields, append, remove } = useFieldArray({ control, name: 'receivables' });

  if (!isLegalEntity) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        10. Дебіторська заборгованість
      </Typography>
      <FinancialConditionTable
        ariaLabel={RECEIVABLES_TABLE_ARIA_LABEL}
        headers={[...RECEIVABLES_TABLE_HEADERS]}
        showActions={fields.length > 1}
        dateColumnIndexes={[...RECEIVABLES_DATE_COLUMN_INDEXES]}
        columnWidths={[...RECEIVABLES_TABLE_COLUMN_WIDTHS]}
        minWidth={RECEIVABLES_TABLE_MIN_WIDTH}
      >
        {fields.map((field, index) => (
          <ReceivableRow
            key={field.id}
            index={index}
            canRemove={fields.length > 1}
            disabled={disabled}
            onRemove={() => remove(index)}
          />
        ))}
      </FinancialConditionTable>
      <Button
        variant="outlined"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => append(createReceivable())}
        disabled={disabled}
        sx={documentGenerationFormStyles.addButton}
      >
        Додати заборгованість
      </Button>
    </Box>
  );
};
